import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { makeRenderable } from '@universal-ember/react';
import { MarkerType } from '@xyflow/react';
import { ReactFlowDiagram } from '../react/flow/react-flow-diagram.jsx';

export default class FlowEditorComponent extends Component {
  @tracked nodes = [
    {
      id: '1',
      position: { x: 250, y: 25 },
      data: { label: 'Nodo 1' },
      type: 'input',
    },
    {
      id: '2',
      position: { x: 100, y: 125 },
      data: { label: 'Nodo 2' },
    },
    {
      id: '3',
      position: { x: 400, y: 125 },
      data: { label: 'Nodo 3' },
      type: 'output',
    },
  ];

  @tracked edges = [
    {
      id: 'e1-2',
      source: '1',
      target: '2',
      animated: true,
      label: 'edge 1',
    },
    {
      id: 'e2-3',
      source: '2',
      target: '3',
      animated: true,
      label: 'edge 2'
    },
  ];

  // Crear el componente React renderizable
  ReactFlowWrapper = makeRenderable(ReactFlowDiagram);

  constructor() {
    super(...arguments);

    window.addEventListener('react-flow-save', this.handleReactFlowSave.bind(this));
  }

  willDestroy() {
    super.willDestroy();
    window.removeEventListener('react-flow-save', this.handleReactFlowSave.bind(this));
  }

  @action
  handleReactFlowSave(event) {
    const { nodes, edges, flow } = event.detail;
    console.log('Received from React Flow:', { nodes, edges, flow });

    this.saveToBackend({ nodes, edges, flow });
  }

  @action
  handleNodesChange(changes, newNodes) {
    console.log('Nodes changed in Ember:', changes);
  }

  @action
  handleEdgesChange(changes, newEdges) {
    console.log('Edges changed in Ember:', changes);
  }

  @action
  saveToBackend(flowData) {
    console.log('Guardando en backend:', flowData);
  }

  @action
  loadFlow() {
    console.log('Cargando flujo...');
  }

  @action
  exportFlow() {
    console.log('Exportando flujo...');
  }
}